import Vue from "vue";

const root = new Vue().$root;

class EventBus {
  emit = {
    mapZoom(zoom) {
      root.$emit('mapZoom', zoom);
    },
    mapCenter(center) {
      root.$emit('mapCenter', center)
    },
    position(position) {
      root.$emit('position', position);
    },
    place(place) {
      root.$emit('place', place);
    },
    clearPlace() {
      root.$emit('clearPlace');
    },
    zoomIn(position, zoom) {
      root.$emit('zoomIn', position, zoom);
    },
    createMarker(event) {
      root.$emit('createMarker', event);
    },
    newMarker() {
      root.$emit('newMarker');
    },
    invalidData(data) {
      root.$emit('invalidData', data);
    },
    createFromSidebar() {
      root.$emit('createFromSidebar');
    },
    clearSearch() {
      root.$emit('clearSearch');
    }
  }

  on = {
    mapZoom(cb) {
      root.$on('mapZoom', cb);
    },
    mapCenter(cb) {
      root.$on('mapCenter', cb);
    },
    position(cb) {
      root.$on('position', cb);
    },
    place(cb) {
      root.$on('place', cb);
    },
    clearPlace(cb) {
      root.$on('clearPlace', cb);
    },
    zoomIn(cb) {
      root.$on('zoomIn', cb);
    },
    createMarker(cb) {
      root.$on('createMarker', cb);
    },
    newMarker(cb) {
      root.$on('newMarker', cb);
    },
    invalidData(cb) {
      root.$on('invalidData', cb);
    },
    createFromSidebar(cb) {
      root.$on('createFromSidebar', cb);
    },
    clearSearch(cb) {
      root.$on('clearSearch', cb);
    }
  }
}

const eventBus = new EventBus();
export default eventBus;
